<!-- Diálogos de creación/edición de cliente -->
<p-dialog
    [header]="customer && customer.id ? 'Editar Contacto/Cliente' : 'Nuevo Contacto/Cliente'"
    [(visible)]="visible"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="cerrarPopup(false);">
    
    <form
        #contactoEditorForm="ngForm"
        (ngSubmit)="guardarContacto()"
        [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{ customer && customer.id ? (customer.firstname + ' ' + customer.surname) : '' }}</h2>
            </div>
            <div class="p-field col-6 p-md-6 p-d-flex p-jc-between ">
                <label for="esPersonaNatural">¿Es persona natural? </label>
                <p-inputSwitch 
                    #esExtranjero ="ngModel"
                    id="esPersonaNatural"
                    name="esPersonaNatural"
                    [(ngModel)]="customer.esPersonaNatural"
                    inputId="esPersonaNatural" 
                    mode="currency"
                    (onChange)="handleChangeEsPersonalNatural($event)"
                    ></p-inputSwitch>
                <p-message severity="error" [text]="appConfig['validationMsgs']['radioRequired']" 
                           *ngIf="contactoEditorForm.controls['esPersonaNatural']
                           && !contactoEditorForm.controls['esPersonaNatural'].valid 
                           && (contactoEditorForm.controls['esPersonaNatural'].dirty 
                           || contactoEditorForm.controls['esPersonaNatural'].touched)">
                </p-message>
            </div>
            <div class="p-field col-6 p-md-6 p-d-flex p-jc-between ">
                <label for="esExtranjero">¿Utiliza pasaporte? </label>
                <p-inputSwitch 
                    #esExtranjero ="ngModel"
                    id="esExtranjero"
                    name="esExtranjero"
                    [(ngModel)]="customer.esExtranjero"
                    inputId="esExtranjero" 
                    mode="currency"
                    (onChange)="handleChangeEsExtranjero($event)"
                    ></p-inputSwitch>
                <p-message severity="error" [text]="appConfig['validationMsgs']['radioRequired']" 
                           *ngIf="contactoEditorForm.controls['esExtranjero']
                           && !contactoEditorForm.controls['esExtranjero'].valid 
                           && (contactoEditorForm.controls['esExtranjero'].dirty 
                           || contactoEditorForm.controls['esExtranjero'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-12 p-d-flex p-jc-between" *ngIf="customer.esPersonaNatural && !customer.esExtranjero">
                <label for="subjectCodefrm">C.I/RUC</label>
                <span class="p-input-icon-lef">
                    <i class="pi pi-id-card"></i>
                    <input
                        #subjectCodefrm="ngModel"
                        id="subjectCodefrm"
                        name="subjectCodefrm"
                        type="text"
                        [(ngModel)]="subjectCode"
                        (keyup)="ui.onKey($event)"
                        [minlength]="appConfig.ux.minlengthCIRUC" [maxlength]="appConfig.ux.maxlengthCIRUC"
                        (change)="searchSubjectPorCode($event);"
                        [pattern]="appConfig['validationRegExp']['cirucPattern']"
                        required
                        pInputText
                        placeholder="Ingrese el número de Cédula de Identidad o RUC de su cliente" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['cirucPattern']"
                    *ngIf="
                    contactoEditorForm.controls['subjectCodefrm'] &&
                    !contactoEditorForm.controls['subjectCodefrm'].valid &&
                    (contactoEditorForm.controls['subjectCodefrm'].dirty ||
                    contactoEditorForm.controls['subjectCodefrm'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-12 p-d-flex p-jc-between" *ngIf="!customer.esPersonaNatural && !customer.esExtranjero">
                <label for="subjectCodefrm">RUC</label>
                <span class="p-input-icon-lef">
                    <i class="pi pi-id-card"></i>
                    <input
                        #subjectCodefrm="ngModel"
                        id="subjectCodefrm"
                        name="subjectCodefrm"
                        type="text"
                        [(ngModel)]="subjectCode"
                        (keyup)="ui.onKey($event)"
                        [minlength]="appConfig.ux.maxlengthCIRUC" [maxlength]="appConfig.ux.maxlengthCIRUC"
                        (change)="searchSubjectPorCode($event);"
                        [pattern]="appConfig['validationRegExp']['rucPattern']"
                        required
                        pInputText
                        placeholder="Ingrese el número de RUC de su cliente" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['cirucPattern']"
                    *ngIf="
                    contactoEditorForm.controls['subjectCodefrm'] &&
                    !contactoEditorForm.controls['subjectCodefrm'].valid &&
                    (contactoEditorForm.controls['subjectCodefrm'].dirty ||
                    contactoEditorForm.controls['subjectCodefrm'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-4 p-md-4 p-d-flex p-jc-between " *ngIf='customer.esPersonaNatural && !customer.esExtranjero'>
                <label for="esCedulaDiferenteAlRUC">¿La cédula es diferente al RUC? </label>
                <p-inputSwitch 
                    #esCedulaDiferenteAlRUC ="ngModel"
                    id="esCedulaDiferenteAlRUC"
                    name="esCedulaDiferenteAlRUC"
                    [(ngModel)]="customer.esCedulaDiferenteAlRUC"
                    inputId="esCedulaDiferenteAlRUC" 
                    mode="currency"
                    (onChange)="handleChangeEsCedulaDiferenteAlRUC($event)"
                    ></p-inputSwitch>
                <p-message severity="error" [text]="appConfig['validationMsgs']['radioRequired']" 
                           *ngIf="contactoEditorForm.controls['esCedulaDiferenteAlRUC']
                           && !contactoEditorForm.controls['esCedulaDiferenteAlRUC'].valid 
                           && (contactoEditorForm.controls['esCedulaDiferenteAlRUC'].dirty 
                           || contactoEditorForm.controls['esCedulaDiferenteAlRUC'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-12 p-d-flex p-jc-between" *ngIf="customer.esPersonaNatural && customer.esExtranjero">
                <label for="subjectCodefrm">PASAPORTE</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-id-card"></i>
                    <input
                        #subjectCodefrm="ngModel"
                        id="subjectCodefrm"
                        name="subjectCodefrm"
                        type="text"
                        [(ngModel)]="subjectCode"
                        (keyup)="ui.onKey($event)"
                        [minlength]="2" [maxlength]="16"
                        (change)="searchSubjectPorCode($event);"
                        [pattern]="appConfig['validationRegExp']['siglasPattern']"
                        required
                        pInputText
                        placeholder="Ingrese código de pasaporte de su cliente" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['siglasPattern']"
                    *ngIf="
                    contactoEditorForm.controls['subjectCodefrm'] &&
                    !contactoEditorForm.controls['subjectCodefrm'].valid &&
                    (contactoEditorForm.controls['subjectCodefrm'].dirty ||
                    contactoEditorForm.controls['subjectCodefrm'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-8 p-md-8 p-d-flex p-jc-between" *ngIf="customer.esCedulaDiferenteAlRUC && !customer.esExtranjero">
                <label for="subjectNUIfrm">NUI (Cédula de identidad)</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-id-card"></i>
                    <input
                        #subjectNUIfrm="ngModel"
                        id="subjectNUIfrm"
                        name="subjectNUIfrm"
                        type="text"
                        [(ngModel)]="subjectNUI"
                        [pattern]="appConfig['validationRegExp']['cirucPattern']"
                        [required]="customer.esCedulaDiferenteAlRUC"
                        pInputText
                        placeholder="Ingrese el NUI (número de cédula de identidad)" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['cirucPattern']"
                    *ngIf="
                    contactoEditorForm.controls['subjectNUIfrm'] &&
                    !contactoEditorForm.controls['subjectNUIfrm'].valid &&
                    (contactoEditorForm.controls['subjectNUIfrm'].dirty ||
                    contactoEditorForm.controls['subjectNUIfrm'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-12 p-sm-12">
                <label for="nombres">Nombres</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-user"></i>
                    <input
                        #nombre="ngModel"
                        id="nombres"
                        name="nombres"
                        type="text"
                        [(ngModel)]="customer.firstname"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        required
                        pInputText
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Ingrese los Nombres de su cliente o registre la razón social de su cliente" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="
                    contactoEditorForm.controls['nombres'] &&
                    !contactoEditorForm.controls['nombres'].valid &&
                    (contactoEditorForm.controls['nombres'].dirty || 
                    contactoEditorForm.controls['nombres'].touched) &&
                    customer && !customer.id
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-12 p-sm-12">
                <label for="apellidos">Apellidos</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-user"></i>
                    <input
                        #apellidos="ngModel"
                        id="apellidos"
                        name="apellidos"
                        type="text"
                        [(ngModel)]="customer.surname"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        pInputText
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Ingrese los Apellidos o Tipo de compañia de su cliente. Si el cliente es una compañia indique el tipo. Ej.: CIA LTDA, S.A, SAS" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern'].concat('. Si el cliente es una compañia indique el tipo. Ej.: CIA LTDA, S.A, SAS')"
                    *ngIf="
                    contactoEditorForm.controls['apellidos'] &&
                    !contactoEditorForm.controls['apellidos'].valid &&
                    (contactoEditorForm.controls['apellidos'].dirty ||
                    contactoEditorForm.controls['apellidos'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-d-flex p-jc-between">
                <label for="noTieneCorreoElectronico">¿Usa un correo electrónico de un familiar u otra persona? </label>
                <p-inputSwitch 
                    #tieneCorreoElectronico ="ngModel"
                    id="noTieneCorreoElectronico"
                    name="noTieneCorreoElectronico"
                    [(ngModel)]="customer.noTieneCorreoElectronico"
                    inputId="noTieneCorreoElectronico" 
                    mode="currency"
                    (onChange)="searchEmailByCode($event);"
                    ></p-inputSwitch>
                <p-message severity="error" [text]="appConfig['validationMsgs']['radioRequired']" 
                           *ngIf="contactoEditorForm.controls['noTieneCorreoElectronico']
                           && !contactoEditorForm.controls['noTieneCorreoElectronico'].valid 
                           && (contactoEditorForm.controls['noTieneCorreoElectronico'].dirty 
                           || contactoEditorForm.controls['noTieneCorreoElectronico'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Correo electrónico</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-envelope"></i>
                    <input
                        pInputText
                        #email="ngModel"
                        id="email"
                        name="email"
                        type="text"
                        [(ngModel)]="customer.email"
                        [pattern]="appConfig['validationRegExp']['emailPattern']"
                        required
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Ingrese la dirección de Correo electrónico de su cliente, para enviarle la Factura electrónica"
                        (change)="searchEmailByCode($event);"/>
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['emailCustomerPattern']"
                    *ngIf="
                    contactoEditorForm.controls['email'] &&
                    !contactoEditorForm.controls['email'].valid &&
                    (contactoEditorForm.controls['email'].dirty || contactoEditorForm.controls['email'].touched)
                    || !emailValid
                    ">
                </p-message>
            </div>
            <div class="p-field col-4 p-md-12 p-sm-12">
                <label for="ciudad">Ciudad</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input
                        pInputText 
                        #ciudad="ngModel"
                        id="ciudad"
                        name="ciudad"
                        type="text"
                        [(ngModel)]="customer.ciudad"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Ingrese la ciudad donde se encuentra su cliente"/>
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="
                    contactoEditorForm.controls['ciudad'] &&
                    !contactoEditorForm.controls['ciudad'].valid &&
                    (contactoEditorForm.controls['ciudad'].dirty ||
                    contactoEditorForm.controls['ciudad'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-8 p-md-12 p-sm-12">
                <label for="nombre">Dirección</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input
                        #direccion="ngModel"
                        id="direccion"
                        name="direccion"
                        type="text"
                        [(ngModel)]="customer.direccion"
                        [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                        [maxlength]="appConfig.app.text.max_length"
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        pInputText
                        placeholder="Registre la dirección donde se encuentra ubicado su cliente" 
                        required="true"/>
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    contactoEditorForm.controls['direccion'] &&
                    !contactoEditorForm.controls['direccion'].valid &&
                    (contactoEditorForm.controls['direccion'].dirty ||
                    contactoEditorForm.controls['direccion'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-6 p-md-12 p-sm-12">
                <label for="mobil">Teléfono móvil</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-phone"></i>
                    <input
                        pInputText
                        #mobil="ngModel"
                        id="mobil"
                        name="mobil"
                        type="text"
                        [(ngModel)]="customer.mobileNumber"
                        (keyup)="ui.onKey($event)"
                        [pattern]="appConfig['validationRegExp']['numberPattern']"
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Registre el número de teléfono móvil de su cliente" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['numberPattern']"
                    *ngIf="
                    contactoEditorForm.controls['mobil'] &&
                    !contactoEditorForm.controls['mobil'].valid &&
                    (contactoEditorForm.controls['mobil'].dirty ||
                    contactoEditorForm.controls['mobil'].touched)">
                </p-message>
            </div>
            <div class="p-field col-6 p-md-12 p-sm-12">
                <label for="work">Teléfono trabajo</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-phone"></i>
                    <input
                        pInputText
                        #work="ngModel"
                        id="work"
                        name="work"
                        type="text"
                        [(ngModel)]="customer.workPhoneNumber"
                        (keyup)="ui.onKey($event)"
                        [disabled]="(customer.usuarioAPP || !customer.usuarioOwner)"
                        placeholder="Ingrese el número de teléfono fijo de su cliente" />
                </span>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button
                    pButton
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="cerrarPopup(false);"></button>
                <button
                    pButton
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check"
                    [disabled]="(!contactoEditorForm.valid || !subjectCodeValid || (!this.emailValid))">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
    